import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import PageLoader from '@/components/layouts/PageLoader.tsx';

const base = import.meta.env.VITE_BASE_PATH;

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 3,
    },
  },
});

run();

async function run() {
  startReactApp();
}

function startReactApp() {
  const root = createRoot(document.getElementById('root')!);

  if (!root) {
    throw new Error('Root element not found');
  }

  root.render(
    <StrictMode>
      <BrowserRouter basename={base}>
        <QueryClientProvider client={queryClient}>
          <Suspense
            fallback={
              <div className="flex w-full h-screen justify-center items-center bg-gray-50 ">
                <PageLoader />
              </div>
            }
          >
            <App />
          </Suspense>
        </QueryClientProvider>
      </BrowserRouter>
    </StrictMode>
  );
}
